export interface IPaginationResultThreads<T> {
  totalPages: number;
  totalItems: number;
  itemsPerPage: number;
  currentPage: number;
  isLastPage: boolean;
  messages: T[];
}

export interface IOnboardingThread {
  id: string;
  admin: boolean;
  automated: boolean;
  fileId: string;
  groupId: string;
  options: Array<any>;
  studioId: string;
  text: string;
  threadId: string;
  type: string;
  sender: string;
  senderEmail: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface IOnboardingThreadApi {
  _id: string;
  admin: boolean;
  automated: boolean;
  createdAt: string;
  fileId: string;
  groupId: string;
  options: Array<any>;
  studioId: string;
  text: string;
  threadId: string;
  type: string;
  sender: string;
  senderEmail: string;
  updatedAt: string;
}

export default class OnboardingThread implements IOnboardingThread {
  public readonly id: string;

  public readonly admin: boolean;

  public readonly automated: boolean;

  public readonly fileId: string;

  public readonly groupId: string;

  public readonly options: Array<any>;

  public readonly studioId: string;

  public readonly text: string;

  public readonly threadId: string;

  public readonly type: string;

  public readonly sender: string;

  public readonly senderEmail: string;

  public readonly createdAt: Date;

  public readonly updatedAt: Date;

  constructor(
    id: string,
    admin: boolean,
    automated: boolean,
    fileId: string,
    groupId: string,
    options: Array<any>,
    studioId: string,
    text: string,
    threadId: string,
    type: string,
    sender: string,
    senderEmail: string,
    createdAt: Date,
    updatedAt: Date,
  ) {
    this.id = id;
    this.admin = admin;
    this.automated = automated;
    this.fileId = fileId;
    this.groupId = groupId;
    this.options = options;
    this.studioId = studioId;
    this.text = text;
    this.threadId = threadId;
    this.type = type;
    this.sender = sender;
    this.senderEmail = senderEmail;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
  }

  static fromApiModel(apiModel: IOnboardingThreadApi) {
    const {
      _id,
      admin,
      automated,
      fileId,
      groupId,
      options,
      studioId,
      text,
      threadId,
      type,
      sender,
      senderEmail,
    } = apiModel;

    const createdAt = new Date(Date.parse(apiModel.createdAt));
    const updatedAt = new Date(Date.parse(apiModel.updatedAt));

    return new OnboardingThread(
      _id,
      admin,
      automated,
      fileId,
      groupId,
      options,
      studioId,
      text,
      threadId,
      type,
      sender,
      senderEmail,
      createdAt,
      updatedAt,
    );
  }

  static arrayFromApiModel(arrayApiModel: IOnboardingThreadApi[]) {
    const array = arrayApiModel.map(apiModel => this.fromApiModel(apiModel));

    return array;
  }

  static arrayPaginatedFromApiModel(
    arrayApiModel: IPaginationResultThreads<IOnboardingThreadApi>,
  ) {
    const array = this.arrayFromApiModel(arrayApiModel.messages);

    return {
      ...arrayApiModel,
      messages: array,
    };
  }
}
